import React, { useContext, useEffect, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { Link } from "react-router-dom";
import { imgBaseUrl } from "../Const";
import NoPropertyImg from "../images/no_property.png";
import { formatNumber, formatShortNumber, onAgtError, onError } from "./CommonFun";
import ImagesModal from "./modal/ImagesModal";
import { AuthContext } from "../context/AuthContext";
import { fatchcompletionTypeFind, objectPSSalesType } from "./CommonApi";
import Login from "../pages/common/Login";
import { REBathtub, REBedOutline, RECamera, RELocation, REMdHeart, RESQFOOT } from "./icons/IconSvg";

export default function PropertySlider({ ltsProperties, perViewFlag }) {
    const { completionType, fetchCompletionType, ppsSaleType, fetchPPSSaleType } = useContext(AuthContext);
    const [favList, setFavList] = useState([]);
    const [imgModalShow, setImgModalShow] = useState(false);
    const [propertyImgsmdl, setPropertyImgsmdl] = useState([]);
    const [propertyData, setProperyData] = useState([]);
    const [loginModal, setLoginModal] = useState(false);
    const [isAuth, setISAuth] = useState(null);

    const handleLoginOpen = () => setLoginModal(true);
    const handleLoginClose = () => setLoginModal(false);

    useEffect(() => {
        if (ltsProperties && ltsProperties.length > 0) {
            if (ppsSaleType.length > 0 || completionType.length > 0) {
                let prpData = fatchcompletionTypeFind(completionType, ltsProperties);
                let PData = objectPSSalesType(ppsSaleType, "purposeSaleName", prpData);
                setProperyData(PData);
            } else setProperyData(ltsProperties);
        }
    }, [ltsProperties, ppsSaleType]);

    useEffect(() => {
        const storedFavs = JSON.parse(localStorage.getItem("favProperty")) || [];
        setFavList(storedFavs);
        fetchPPSSaleType();
        fetchCompletionType();
    }, []);

    const handleFavProperty = (data) => {
        const favProperty = JSON.parse(localStorage.getItem("favProperty")) || [];
        const updatedFavs = favProperty.some((p) => p.id === data.id) ? favProperty : [...favProperty, data];
        setFavList(updatedFavs);
        localStorage.setItem("favProperty", JSON.stringify(updatedFavs));
    };
    const handleDisFavProperty = (data) => {
        const newLikedCoins = favList.filter((coin) => coin.id !== data.id);
        setFavList(newLikedCoins);
        localStorage.setItem("favProperty", JSON.stringify(newLikedCoins));
    };
    const handleDetails = (item) => {
        const data = {
            slug: item.slug,
            eventID: item.uId,
        };
        localStorage.setItem("pty_storage", JSON.stringify(data));
    };
    const handleClose = () => {
        setImgModalShow(false);
        setPropertyImgsmdl([]);
    };
    return (
        <>
            <Swiper
                modules={[Navigation]}
                slidesPerView={1}
                spaceBetween={10}
                navigation={{ nextEl: ".custom-next", prevEl: ".custom-prev" }}
                loop={false}
                breakpoints={{
                    1400: { slidesPerView: perViewFlag ? 2 : 4 },
                    1300: { slidesPerView: perViewFlag ? 2 : 3 },
                    997: { slidesPerView: perViewFlag ? 2 : 3 },
                    768: { slidesPerView: perViewFlag ? 1 : 2 },
                    575: { slidesPerView: perViewFlag ? 1 : 2 },
                    480: { slidesPerView: perViewFlag ? 1 : 1 },
                }}
                className="Swiper-height"
            >
                {propertyData.length > 0 &&
                    propertyData.map((slide, index) => (
                        <SwiperSlide key={index}>
                            <div className="slider-card-prp slider-body position-relative">
                                <Link to={`/property/details/${slide.slug}_${slide.uId}`} title={slide.title} onClick={() => handleDetails(slide)} className="link_anchor"></Link>
                                    <div className="slide-card-img slider-card-het">
                                        {slide.images.length > 0 ? (
                                            (() => {
                                                const coverImg = slide.images.find((img) => img.isCover && !img.needHide);
                                                return (
                                                    <div className="crad_wrapper_img position-relative">
                                                        <img src={coverImg && coverImg !== undefined && coverImg !== null ? imgBaseUrl + coverImg?.path : slide.images[1]?.path ? imgBaseUrl + slide.images[1]?.path : NoPropertyImg} alt={slide.title} onError={onError} loading="lazy" />
                                                        {slide?.purposeType && (
                                                            <div className="tag_label">
                                                                <p>For {slide?.purposeType}</p>
                                                            </div>
                                                        )}
                                                        {slide?.completionType && (
                                                            <div className="plan-label">
                                                                <span>
                                                                    {slide?.completionType ? slide?.completionName : slide?.completionType}
                                                                    {slide?.purposeSalesType ? ` | ${slide?.purposeSaleName ? slide?.purposeSaleName : slide?.purposeSalesType}` : ""}
                                                                </span>
                                                            </div>
                                                        )}
                                                        <div className="card-actions z_index-1">
                                                            <button
                                                                className="btn-camera"
                                                                onClick={(e) => {
                                                                    if (slide.images.length > 0) {
                                                                        e.stopPropagation();
                                                                        e.preventDefault();
                                                                        setImgModalShow(true);
                                                                        setPropertyImgsmdl(slide.images);
                                                                    }
                                                                }}
                                                            >
                                                                <RECamera />
                                                            </button>
                                                            <button
                                                                className="btn-favorite"
                                                                onClick={(e) => {
                                                                    e.preventDefault();
                                                                    e.stopPropagation();
                                                                    if (isAuth) handleDisFavProperty(slide);
                                                                    else handleLoginOpen();
                                                                }}
                                                            >
                                                                <REMdHeart />
                                                            </button>
                                                        </div>
                                                    </div>
                                                );
                                            })()
                                        ) : (
                                            <img src={NoPropertyImg} alt="no property" />
                                        )}
                                    </div>
                                    <div className="heading_title">
                                        <h3 className="card_ellipsis">{slide?.title}</h3>
                                    </div>

                                    {slide.address?.locality && (
                                        <div className="geo-location">
                                            <RELocation />
                                            {/* <span className="card_ellipsis">{slide.address?.locality + slide.address?.city}</span> */}
                                            <span className="card_ellipsis">{[slide?.address?.locality, slide?.address?.city, slide?.address?.state].filter(Boolean).join(", ")}</span>
                                        </div>
                                    )}
                                    {slide.monetary?.expectedPrice && (
                                        <div className="property-price pb-0">
                                            <p>
                                                <bdi>{slide.monetary?.currency}</bdi> {formatShortNumber(slide.monetary?.expectedPrice)}
                                            </p>
                                        </div>
                                    )}
                                    <div className="property-data border border-0">
                                        <div className="property-details">
                                            {slide.category.name && (
                                                <div className="detail-item">
                                                    <div className="detail-count">
                                                        <p>{slide.category.name}</p>
                                                    </div>
                                                </div>
                                            )}
                                            {slide.noOfBhk && (
                                                <div className="detail-item">
                                                    <div className="detail-count">
                                                        {/* <img src={bedroomImg} alt="" /> */}
                                                        <REBedOutline />
                                                        <p>{slide.noOfBhk && (parseInt(slide.noOfBhk) === parseInt(0) ? "Studio" : slide.noOfBhk)}</p>
                                                    </div>
                                                </div>
                                            )}
                                            {slide?.frame?.bathRooms && (
                                                <div className="detail-item">
                                                    <div className="detail-count">
                                                        {/* <img src={bathroomImg} alt="" /> */}
                                                        <REBathtub />
                                                        <p>{slide?.frame?.bathRooms ?? 0}</p>
                                                    </div>
                                                </div>
                                            )}
                                            {slide?.dimension?.propertyArea && slide.dimension.unit && (
                                                <div className="detail-item">
                                                    <div className="detail-count">
                                                        {/* <img src={squareImg} alt="" /> */}
                                                        <RESQFOOT />
                                                        <p>{formatNumber(slide?.dimension?.propertyArea)}</p>
                                                        <p>{slide.dimension.unit}</p>
                                                    </div>
                                                </div>
                                            )}
                                        </div>
                                        {/* {slide?.rating && slide?.rating > 0 && (
                                            <div className="property_data_inner">
                                                {(slide?.rating == 1 || slide?.rating == 2) && <p className="cold">Cold</p>}
                                                {slide?.rating == 3 && <p className="warm">Warm</p>}
                                                {(slide?.rating == 4 || slide?.rating == 5) && <p className="hot">Hot</p>}
                                            </div>
                                        )} */}
                                    </div>
                                    {slide?.agents && slide?.agents?.isHighlyResponsive && (
                                        <div className="property-data pb-2">
                                            <div className="agent_intro">
                                                <div className="agent_avatar">
                                                    <div className="agent_avatar_icon">
                                                        <img src={imgBaseUrl + slide?.agents?.path} alt={slide?.agents?.name} onError={onAgtError} loading="lazy" />
                                                        {/* <div className="agent_icon_wrp">
                                                            <RiMedal2Fill color="#fff" />
                                                        </div> */}
                                                    </div>
                                                    <Link to={`/agent-details/${slide?.agents?.uId}`}>
                                                        <p>{slide?.agents?.name}</p>
                                                    </Link>
                                                </div>
                                            </div>
                                        </div>
                                    )}
                                
                            </div>
                        </SwiperSlide>
                    ))}
            </Swiper>
            <div className="navigation_btn">
                <button className={`custom-prev ${propertyData.length === 2 ? "swiper-button-lock" : ""}`} aria-label="Previous Slide">
                    ❮
                </button>
                <button className="custom-next" aria-label="Next Slide">
                    ❯
                </button>
            </div>
            <ImagesModal show={imgModalShow} handleHide={handleClose} propertyImgsmdl={propertyImgsmdl} />
            {loginModal && <Login show={loginModal} handleHide={handleLoginClose} onShow={handleLoginOpen} />}
        </>
    );
}
